import * as documentPackageActions from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.actions";
import {
  EDocumentPackageSignerStatus,
  IDocumentPackage,
} from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Icon } from "@rentiohq/web-shared/dist/components";
import { useDispatch } from "react-redux";
import { findUniqueSigner } from "../../../../../utils/documentPackage.utils";

export const generateGetDocumentPackageSignerActions =
  (paramsGenerator: {
    dispatch: ReturnType<typeof useDispatch>;
    documentPackage: IDocumentPackage;
  }) =>
  (params: { accountIds: number[] }) => {
    const { dispatch, documentPackage } = paramsGenerator;
    const { accountIds } = params;

    const signer = findUniqueSigner(documentPackage, accountIds);
    if (!signer) {
      return [];
    }

    const result = [];

    // Open connective url
    if (
      signer.connectiveUrl &&
      signer.status !== EDocumentPackageSignerStatus.Finished
    ) {
      result.push({
        content: getLocalizedText("document_package.sign_for_signer.cta.title"),
        media: <Icon source="contentPenWrite" />,
        onClick: () => {
          window.open(signer.connectiveUrl, "_blank");
        },
      });
    }

    // Reminder
    if (signer.status !== EDocumentPackageSignerStatus.Finished) {
      result.push({
        content: getLocalizedText("document_package.remind_signer.cta.title"),
        media: <Icon source="email" />,
        onClick: () => {
          dispatch(
            documentPackageActions.remindDocumentPackageSignerStart.getAction({
              documentPackageId: documentPackage.id,
              signerAccountId: signer.accountId,
            }),
          );
        },
      });
    }

    return result;
  };
